module.exports = __webpack_public_path__ + "static/media/08.5c3ab90e.mp3";